<template>
  <el-dialog
    :title="$t('deleteOrg.title')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div class="text-center">
      <p>{{ $t('deleteOrg.confirmDelete') }}</p>
    </div>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('deleteOrg.cancel') }}</el-button>
      <el-button type="primary" @click="deleteOrg">{{ $t('deleteOrg.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteOrg } from '@/api/frame/orgApi'

export default {
  name: 'DeleteOrg',
  data() {
    return {
      dialogVisible: false,
      deleteOrgInfo: {}
    }
  },
  methods: {
    open(params) {
      this.dialogVisible = true
      this.deleteOrgInfo = params || {}
    },
    deleteOrg() {
      deleteOrg(this.deleteOrgInfo).then(response => {
        this.$message.success(this.$t('deleteOrg.deleteSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    handleClose() {
      this.deleteOrgInfo = {}
    }
  }
}
</script>

<style scoped>
.text-center {
  text-align: center;
}
</style>